module.exports = __webpack_public_path__ + "media/images/icons/sw-pt2-icon-ad00972bf6ef8f4785c932fa69f91039.svg";